import React, { useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import {API_BASE_URL}  from '../../constants/constants.js'; // Adjust the import path as necessary
const DataTableListNew = () => {
  const [tables, setTables] = useState([]);
//https://www.po.sriyansh.co.in/auditreports

const [pageLoader, setPageLoader] = useState(false);
  useEffect(() => {
    setPageLoader(true);
    fetch(`${API_BASE_URL}/auditreports`) // Adjust the URL if needed
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setTables(data);
        } else {
          console.error('Unexpected data format:', data);
        }
        setPageLoader(false);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  // Function to render a single table
 const renderTable = (table, index) => {
  // Check if the table is a valid non-empty array
  if (!Array.isArray(table) || table.length === 0) return null;

  const firstObject = table[0];

  if (!firstObject || typeof firstObject !== "object") {
    return null;
  }

  const heading = `${index + 1}`;

  return (
    <Card
      key={index}
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        mb: { xs: 1.5, sm: 2, md: 2.5 },
        borderRadius: 2,
        border: "1px solid #dbe5f0",
        boxShadow: "0 2px 10px rgba(13, 71, 161, 0.07)",
        backgroundColor: "#fff",
      }}
    >
      {/* ================= REPORT HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #1565C0 0%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.25, sm: 1.75, md: 2 },
          py: { xs: 0.9, sm: 1 },
          display: "flex",
          alignItems: "center",
          minHeight: { xs: 42, sm: 46 },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "0.82rem", sm: "0.9rem", md: "0.95rem" },
            fontWeight: 700,
          }}
        >
          Audit Report Number {heading}
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 0.75, sm: 1, md: 1.25 },
          "&:last-child": {
            pb: { xs: 0.75, sm: 1, md: 1.25 },
          },
        }}
      >
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            overflowX: "hidden",
            border: "1px solid #dbe5f0",
            borderRadius: 1.5,
          }}
        >
          <Table
            size="small"
            sx={{
              width: "100% !important",
              maxWidth: "100% !important",
              minWidth: "0 !important",
              tableLayout: "fixed !important",
              borderCollapse: "collapse",

              "& th, & td": {
                whiteSpace: "normal !important",
                overflowWrap: "anywhere !important",
                wordBreak: "break-word !important",
                verticalAlign: "top",
                boxSizing: "border-box",
              },

              "& th": {
                fontSize: {
                  xs: "0.68rem",
                  sm: "0.76rem",
                  md: "0.82rem",
                },
                fontWeight: 700,
                lineHeight: 1.35,
                padding: {
                  xs: "7px 5px",
                  sm: "8px 6px",
                  md: "9px 7px",
                },
              },

              "& td": {
                fontSize: {
                  xs: "0.67rem",
                  sm: "0.74rem",
                  md: "0.8rem",
                },
                lineHeight: 1.4,
                padding: {
                  xs: "7px 5px",
                  sm: "8px 6px",
                  md: "9px 7px",
                },
                color: "#26384a",
              },

              "& tbody tr:nth-of-type(even)": {
                backgroundColor: "#f8fbff",
              },

              "& tbody tr:hover": {
                backgroundColor: "#eaf3ff",
              },

              "& tbody tr:last-child td": {
                borderBottom: "none",
              },
            }}
          >
            <TableHead>
              <TableRow>
                {Object.keys(firstObject).map((key) => (
                  <TableCell
                    key={key}
                    sx={{
                      background:
                        "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%) !important",
                      color: "#fff !important",
                      fontWeight: 700,
                      whiteSpace: "normal !important",
                      overflowWrap: "anywhere !important",
                      wordBreak: "break-word !important",
                    }}
                  >
                    {key}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {table.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {Object.values(row).map((value, colIndex) => (
                    <TableCell
                      key={colIndex}
                      sx={{
                        whiteSpace: "normal !important",
                        overflowWrap: "anywhere !important",
                        wordBreak: "break-word !important",
                      }}
                    >
                      {value !== null &&
                      value !== undefined &&
                      value !== ""
                        ? String(value)
                        : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

 return (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
      p: { xs: 1, sm: 1.5, md: 2 },
    }}
  >
    <Card
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 2.5 },
        border: "1px solid #dbe5f0",
        boxShadow: "0 4px 18px rgba(13, 71, 161, 0.10)",
        backgroundColor: "#fff",
      }}
    >
      {/* ================= MAIN HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.4, sm: 1.6 },
          minHeight: { xs: 54, sm: 60 },
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.15rem", md: "1.3rem" },
            fontWeight: 700,
          }}
        >
          Audit Query Results
        </Typography>
      </Box>

      {/* ================= LOADER ================= */}
      {pageLoader ? (
        <Box
          sx={{
            minHeight: 180,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <CircularProgress
            size={38}
            sx={{
              color: "#1565C0",
            }}
          />

          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "#607d8b",
            }}
          >
            Loading audit results...
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
            p: { xs: 1.25, sm: 1.5, md: 2 },
            overflowX: "hidden",
          }}
        >
          {tables.length > 0 ? (
            tables.map((table, index) => renderTable(table, index))
          ) : (
            <Box
              sx={{
                py: 5,
                textAlign: "center",
                border: "1px dashed #b8c9dc",
                borderRadius: 2,
                backgroundColor: "#f8fbff",
              }}
            >
              <Typography
                sx={{
                  color: "#607d8b",
                  fontSize: { xs: "0.85rem", sm: "0.95rem" },
                }}
              >
                No audit query results found.
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Card>
  </Box>
);
};

export default DataTableListNew;
